import PositioningDeviceFittingChangeUsergroupModal from './positioningdevicefitting-change-usergroup-modal.vue'
export default PositioningDeviceFittingChangeUsergroupModal
